import { render, staticRenderFns } from "./ImageModel.vue?vue&type=template&id=1bcef22c&"
import script from "./ImageModel.vue?vue&type=script&lang=js&"
export * from "./ImageModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports